import { collection, addDoc, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

export type StudyGoal =
  | 'medical_boards'
  | 'law_exam'
  | 'certification'
  | 'language'
  | 'college'
  | 'high_school'
  | 'other';

export interface WaitlistEntry {
  email: string;
  name: string;
  studyGoal: StudyGoal | '';
  joinedAt: Timestamp;
  source: string;
}

export async function addToWaitlist(
  email: string,
  name: string,
  studyGoal: StudyGoal | '',
  source = 'landing_page'
): Promise<void> {
  const existing = await getDocs(
    query(collection(db, 'waitlist'), where('email', '==', email.toLowerCase().trim()))
  );
  if (!existing.empty) return;

  const entry: WaitlistEntry = {
    email: email.toLowerCase().trim(),
    name: name.trim(),
    studyGoal,
    joinedAt: Timestamp.now(),
    source,
  };

  await addDoc(collection(db, 'waitlist'), entry);
}
